// React
import { useHistory, useParams } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { ProposalsInjection } from '../../containers/proposalsInjection';

// Utils & Helpers
import * as url from '../../../../helpers/url_helper';
import { useOffice } from '../../../../hook/useOffice';
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';

// View
import { ProposalsFormPage } from './view';

export const ProposalsForm = (props) => {
  // States
  const [isView, setIsView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [proposal, setProposal] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [viewCancel, setViewCancel] = useState(false);
  const [maxDependents, setMaxDependents] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paymentsTypes, setPaymentsTypes] = useState([]);
  const [showEmployment, setShowEmployment] = useState(false);
  const [showMembership, setShowMembership] = useState(false);
  const [showOrganization, setShowOrganization] = useState(false);
  const [isModalReactivateOpen, setIsModalReactivateOpen] = useState(false);
  const [isModalChangeStatusOpen, setIsModalChangeStatusOpen] = useState(false);

  const {
    files,
    plans,
    sellers,
    offices,
    getPlans,
    kinships,
    services,
    getOffices,
    getSellers,
    getKinship,
    getServices,
    changeStatus,
    categoryPlans,
    organizations,
    cancelProposal,
    updateProposal,
    createProposal,
    reactiveProposal,
    getCategoryPlans,
    getOrganizations,
  } = ProposalsInjection();

  // Helpers & Utilities
  const api = new APIClient();
  const history = useHistory();
  const { office } = useOffice();
  const { proposalId } = useParams();
  const { loadingWithTime } = useLoading();

  // Toggles
  const toggleAlertCancel = () => {
    setViewCancel(!viewCancel);
  };

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  function toggleCancel() {
    setIsModalOpen(!isModalOpen);
  }

  const toggleChangeStatus = () => {
    setIsModalChangeStatusOpen(!isModalChangeStatusOpen);
  };

  const toggleReactivateProposalModal = () => {
    setIsModalReactivateOpen((prevState) => !prevState);
  };

  const toggleAssistenceDependent = async (idDependent) => {
    try {
      await api.create('/proposal/toogle-funeral-assistence-dependent', {
        proposal_id: proposal?.id,
        customer_id: idDependent,
      });

      // Find dependent for get informations and change in list
      const findDependent = validation.values.dependents.find((item) => {
        return item.customer_id === idDependent;
      });

      const target = {
        target: {
          name: 'dependents',
          value: validation.values.dependents.map((item) =>
            item.customer_id === idDependent
              ? {
                  ...findDependent,
                  funeral_assistance: !findDependent.funeral_assistance,
                }
              : item
          ),
        },
      };

      validation.handleChange(target);
    } catch (error) {
      return error;
    }
  };

  /**
   * GET calls
   */
  const getProposalsById = async (hash) => {
    setLoading(true);

    const proposal = await api.get(`/proposal/${hash}`);

    if (proposal) {
      setProposal(proposal);
    }

    setLoading(false);
  };

  const getInfoAboutCustomer = useCallback(async (hash) => {
    const customer = await api.get(`/customer/${hash}`);

    if (customer) {
      setCustomer(customer);
    }
  }, []);

  const getPaymentConditions = useCallback(() => {
    api.get(url.BASE + '/register/payment-condition').then((response) => {
      setPaymentsTypes(createData(response));
    });
  }, []);

  const getMaxDependentInPlans = useCallback(async (planId) => {
    const plan = await api.get(`/register/plan/${planId}`);

    if (plan) {
      setMaxDependents(plan.max_dependents);
      !proposalId &&
        validation.handleChange({
          target: {
            name: 'priceInput',
            value: plan.price,
          },
        });
    }
  }, []);

  function getTime() {
    const date = new Date();

    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }

    const year = date.getFullYear();
    const month = padTo2Digits(date.getMonth() + 1);
    const day = padTo2Digits(date.getDate());

    const withHyphens = [year, month, day].join('-');
    return withHyphens;
  }

  /**
   * Submit's functions
   */
  const handleSubmitCancelModal = (cancelationReason) => {
    loadingWithTime(1000);

    cancelProposal({
      proposal_id: proposal?.id,
      reason: cancelationReason,
    });

    setTimeout(() => {
      getProposalsById(proposalId);
      toggleCancel();
    }, 1000);
  };

  const handleSubmitChangeStatus = (changeReason, idStatus) => {
    loadingWithTime(1000);

    changeStatus({
      proposal_id: proposal?.id,
      reason: changeReason,
      status: idStatus ? idStatus.value : null,
    });

    setTimeout(() => {
      getProposalsById(proposalId);
      toggleChangeStatus();
    }, 1000);
  };

  const handleSubmitReactivateProposal = (reactiveReason) => {
    let body = {
      status_id: 2,
      reason: reactiveReason,
      proposal_id: proposal?.id,
    };

    loadingWithTime(1000);
    reactiveProposal(body);

    setTimeout(() => {
      getProposalsById(proposalId);
      toggleReactivateProposalModal();
    }, 1000);
  };

  Yup.addMethod(Yup.object, 'organization', function (errorMessage) {
    return this.test('organization', errorMessage, function (value) {
      const { path, createError } = this;

      if (!showOrganization) {
        return true;
      } else {
        if (value?.value !== null) {
          return true;
        } else {
          createError({ path, message: errorMessage });
        }
      }
    });
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      categoryPlanInput: proposal?.category_id
        ? {
            value: proposal.category_id,
            label: proposal.category,
          }
        : {
            value: null,
            label: null,
          },
      proposal_status_id: proposal?.proposal_status_id || null,
      planInput: proposal?.plan_id
        ? {
            value: proposal.plan_id,
            label: proposal.plan,
          }
        : {
            value: null,
            label: null,
          },
      organizationInput: proposal?.organization_id
        ? {
            value: proposal.organization_id,
            label: proposal.organization_name,
          }
        : {
            value: null,
            label: '',
          },

      situationInput: proposal?.cadastral_status
        ? {
            value: proposal.cadastral_status,
            label: proposal.cadastral_status,
          }
        : {
            value: null,
            label: '',
          },
      validContractWorkInput: proposal?.work_contract_expiration || null,
      registrationInput: proposal?.registration || '',
      cardNumber: proposal?.card_number || '',

      numberContractInput: proposal?.number || '',
      statusInput: proposal?.status,
      statusColor: proposal?.status_color,
      customerInput: proposal?.customer || '',
      validInput: proposal?.valid_until || '',
      membershipInput: proposal?.membership_fee || '',
      sellerInput: proposal?.seller_id
        ? {
            value: proposal.seller_id,
            label: proposal.seller_name,
          }
        : {
            value: '',
            label: '',
          },
      priceInput: proposal?.price || 0,
      paymentFormInput: proposal?.payment_condition_id
        ? {
            value: proposal.payment_condition_id,
            label: proposal.payment_condition_name,
          }
        : {
            value: '',
            label: '',
          },
      paymentTypeInput: proposal?.periodicity_payment
        ? {
            value: proposal.periodicity_payment,
            label: proposal.periodicity_payment === 'M' ? 'Mensal' : 'Anual',
          }
        : {
            value: '',
            label: '',
          },
      obsInput: proposal?.obs?.replace(/\\n/g, '\n') || '',
      dependents: proposal?.dependents || [],
      services: proposal?.services || [],
      saleAtInput: proposal?.sale_at || getTime(),
      effectiveDateInput: proposal?.effective_date || '',
      funeralAssistance: proposal?.funeral_assistance || false,
      department: proposal?.unit_id
        ? {
            value: proposal.unit_id,
            label: proposal.unit_name,
          }
        : {
            value: null,
            label: '',
          },
      officeInput: proposal?.office_id
        ? {
            value: proposal?.office_id,
            label: proposal?.office_name,
          }
        : !proposalId && office?.office_id
        ? {
            value: office.office_id,
            label: office.name,
          }
        : {
            value: null,
            label: null,
          },
      secretary: proposal?.department || '',
    },
    validationSchema: Yup.object({
      categoryPlanInput: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione uma categoria'),
      planInput: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione um plano'),
      numberContractInput: Yup.string(),
      paymentTypeInput: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione uma periodicidade'),
      statusInput: Yup.string(),
      statusColor: Yup.string(),
      customerInput: Yup.string(),
      validInput: Yup.date()
        .required('Selecione uma data de validade')
        .nullable(),
      sellerInput: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione um corretor'),
      priceInput: Yup.string(),
      membershipInput: Yup.number(),
      paymentFormInput: Yup.object()
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
        .required('Selecione uma condição'),
      saleAtInput: Yup.date().required('Selecione uma periodicidade'),
      effectiveDateInput: Yup.date().required('Selecione uma periodicidade'),
      obsInput: Yup.string().nullable(),
      organizationInput: Yup.object()
        .shape({
          label: Yup.string().nullable(),
          value: Yup.string().nullable(),
        })
        .organization('Selecione uma Organização'),
      situationInput: Yup.object().nullable(),
      validContractWorkInput: Yup.date().nullable(),
      registrationInput: Yup.string().nullable(),
      dependents: Yup.array().nullable(),

      department: Yup.object().shape({
        label: Yup.string().nullable(),
        value: Yup.string().nullable(),
      }),
      officeInput: Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
      secretary: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      const dependents = values.dependents.map((dependent) => {
        return {
          id: dependent.customer_id,
          name: dependent.name,
          birthdate: dependent.birthdate,
          kinship_id: dependent.kinship_id,
          cpf: dependent.cpf,
          funeral_assistance: dependent.funeral_assistance,
          gender: dependent.gender,
          deleted: dependent.deleted || false,
        };
      });

      const servicesSave = values.services.map((service) => {
        return {
          id: service?.id,
          price: service.price,
        };
      });

      const valuesToSubmit = {
        customer_id: (customer && customer.id) || proposal?.customer_id,
        number: values.numberContractInput,
        seller_id: values.sellerInput.value,
        customer: values.customerInput.value,
        plan_id: values.planInput.value,
        periodicity_payment: values.paymentTypeInput.value,
        price: values.priceInput,
        obs: values.obsInput,
        payment_condition_id: values.paymentFormInput.value,
        payment_methods_ids: [],
        valid_until: values.validInput,
        dependents: dependents,
        organization_id: values?.organizationInput?.value || null,
        cadastral_status: values?.situationInput?.value || null,
        work_contract_expiration: values.validContractWorkInput || null,
        registration: values.registrationInput || null,
        services: servicesSave,
        membership_fee: values.membershipInput.toString() || null,
        sale_at: values.saleAtInput,
        effective_date: values.effectiveDateInput,
        unit_id: values?.department?.value || null,
        funeral_assistance: values.funeralAssistance,
        office_id: values.officeInput.value,
        department: values.secretary || null,
      };

      try {
        loadingWithTime(1000);

        if (proposal?.id) {
          updateProposal(
            proposal.id,
            {
              ...valuesToSubmit,
            },
            props.history
          );
        } else {
          createProposal(valuesToSubmit, history);
        }
      } catch (err) {
        return err;
      }
    },
  });

  useEffect(() => {
    getPlans();
    getKinship();
    getSellers();
    getOffices();
    getServices();
    getCategoryPlans();
    getOrganizations();
    getPaymentConditions();
  }, []);

  useEffect(() => {
    if (validation.values.planInput.value) {
      getMaxDependentInPlans(validation.values.planInput.value);
    }
  }, [getMaxDependentInPlans, validation.values.planInput]);

  useEffect(() => {
    const { pathname, search } = window.location;
    const url_array = pathname.split('/');
    const urlParams = new URLSearchParams(search);

    const type_segment = url_array[url_array.length - 2];

    if (type_segment === 'view') {
      setIsView(true);
    }

    if (urlParams.has('customer')) {
      const customer_hashid = urlParams.get('customer');
      getInfoAboutCustomer(customer_hashid);
    }
  }, []);

  useEffect(() => {
    if (proposalId) {
      getProposalsById(proposalId);
    }
  }, [proposalId]);

  return (
    <ProposalsFormPage
      // Data
      filesData={files}
      plansData={plans || []}
      offices={offices || []}
      sellersData={sellers || []}
      hashidProposal={proposalId}
      kinshipsData={kinships || []}
      maxDependents={maxDependents}
      servicesData={services || []}
      paymentMethodsData={paymentsTypes}
      lastUpdated={proposal?.last_update}
      canEdit={proposal && proposal.canEdit}
      categoryPlansData={categoryPlans || []}
      organizationsData={organizations || []}
      idProposal={proposal ? proposal.id : ''}
      customerName={customer ? customer.name : ''}
      canReactivate={proposal && proposal.canReactivate}
      cancellation={proposal ? proposal.cancellation : ''}
      // Utils
      isView={isView}
      history={history}
      loading={loading}
      tabChange={tabChange}
      activeTab={activeTab}
      validation={validation}
      isModalOpen={isModalOpen}
      toggleCancel={toggleCancel}
      showEmployment={showEmployment}
      showMembership={showMembership}
      showOrganization={showOrganization}
      setShowMembership={setShowMembership}
      setShowEmployment={setShowEmployment}
      toggleChangeStatus={toggleChangeStatus}
      setShowOrganization={setShowOrganization}
      isModalReactivateOpen={isModalReactivateOpen}
      handleSubmitCancelModal={handleSubmitCancelModal}
      isModalChangeStatusOpen={isModalChangeStatusOpen}
      handleSubmitChangeStatus={handleSubmitChangeStatus}
      toggleAssistenceDependent={toggleAssistenceDependent}
      toggleReactivateProposalModal={toggleReactivateProposalModal}
      handleSubmitReactivateProposal={handleSubmitReactivateProposal}
    />
  );
};
